// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".personal{margin-top:20px}.personal .btn-container{display:flex;margin:20px -5px;max-width:950px}.personal .btn-container>*{margin-left:5px;margin-right:5px}.personal .unavailable-message{background-color:#5e6163;border-radius:5px;color:#fff;padding:10px;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
